export default __webpack_public_path__ + "9fd6cf20c6caa41c49a9c627ef556bc3.jpg";